/**
 * Shared success/status color tokens for the insights-v2 status surfaces
 * (`StatusPill`, `StatusMessageCard`). Both render a check-icon + text on a
 * green tinted, bordered surface and differ only in geometry (pill vs
 * full-width card), so they share these defaults rather than each hardcoding
 * the same `success.*` tokens.
 */
export const STATUS_SUCCESS_TOKENS = {
  bgcolor: 'success.100',
  borderColor: 'success.main',
  textColor: 'success.darker',
} as const
